<template>
  <div id="app" :class="{ 'android-image-protection': isAndroid }" @contextmenu="preventAndroidImageMenu" @dragstart="preventAndroidImageMenu" @selectstart="preventAndroidImageMenu"><router-view /></div>
</template>
<script>
import { BsGetEnv } from 'dida-web-common'
export default {
  name: 'App',
  // 仅安卓启用图片长按保护，不改变其他环境的默认行为。
  data() { return { isAndroid: BsGetEnv.isAndroid } },
  methods: {
    // 兜底阻止系统菜单、拖拽和选择，不拦截触摸滚动或按钮点击。
    preventAndroidImageMenu(event) { if (this.isAndroid) event.preventDefault() }
  }
}
</script>
<style lang="scss">
html, body { margin: 0; background: #ffebc7; }
body { font-family: Arial, 'PingFang SC', sans-serif; color: #302019; }
* { box-sizing: border-box; }
button { padding: 0; border: 0; background: none; font: inherit; color: inherit; cursor: pointer; }
button:disabled { cursor: default; }
img { display: block; }
#app { min-height: 100vh; }
// 图片不作为触摸命中目标，点击由外层按钮承接；保留原有布局与 CDN 引用。
#app.android-image-protection {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
  img { pointer-events: none; -webkit-user-drag: none; -webkit-touch-callout: none; }
}
</style>
